import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tab-title-inline',
  templateUrl: './tab-title-inline.component.html',
})
export class TabTitleInlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
